module.exports = __webpack_public_path__ + "static/LOGO_SITIMM-f0b488203ad099477ef375c9ba32e877.png";